<!--收藏夹-->
<template>
  <div class="scj">
    <div class="scj-head">
      <van-icon
        name="arrow-left"
        size="17"
        class="scj-head-left"
        color="#33639e"
        @click="handleBackClick"
      ></van-icon>
      <span class="scj-head-text">收藏夹</span>
      <!-- <div class="scj-head-right">编辑</div> -->
    </div>
    <van-empty v-if="emptyFlag" class="scj-body" description="暂无数据" />

    <div class="scj-body" v-else>
      <van-pull-refresh
        style="height:100%;overflow:auto"
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <div
          class="scj-body-item"
          v-for="(item, index) in favoriteList"
          :key="index"
          @click="handleItemClick(item)"
        >
          <div class="scj-body-item-icon">
            <img
              src="../assets/image/zhengchang.png"
              alt=""
              width="100%"
              height="15%"
            />
          </div>
          <div class="scj-body-item-name">{{ item.bc_name }}</div>
          <div class="scj-body-item-cp">{{ item.vehicle_no }}</div>

          <div
            v-if="item.is_favorite"
            class="scj-body-item-status"
            @click.stop="handleCancelCollectionClick(item)"
          >
            <van-icon name="star" size="17" color="red"></van-icon>
          </div>
          <div
            class="scj-body-item-status"
            v-else
            @click.stop="handleCollectionClick(item)"
          >
            <van-icon name="star" size="15" color="#d6d9e0"></van-icon>
          </div>
          <div class="scj-body-item-bottom">
            <div class="scj-body-item-star">{{ item.start_address }}站</div>
            <div class="scj-body-item-right">
              <i class="iconfont icon-right"></i>
            </div>
            <div class="scj-body-item-end">{{ item.end_address }}站</div>
            <div class="scj-body-item-begintime">{{ item.start_time }}</div>
            <div class="scj-body-item-endtime">{{ item.arrive_time }}</div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
// import _ from 'underscore'
import { Dialog } from 'vant'
import { favoritesList } from 'api/FavoriteAPI'
import { cancelFavorite, addFavorite } from 'api/indexAPI'
import { Toast } from 'vant'

export default {
  name: 'Favorite',
  data() {
    return {
      emptyFlag: false,
      isLoading: false,
      favoriteList: []
    }
  },
  computed: {},
  mounted() {
    this.favoritesList()
  },
  methods: {
    handleBackClick() {
      window.history.go(-1)
    },
    //获取列表
    favoritesList() {
      const params = new URLSearchParams()
      params.append('openid', this.$store.state.user.openid)
      favoritesList(params).then(res => {
        if (res.data.success == true) {
          this.favoriteList = res.data.data
          setTimeout(() => {
            this.isLoading = false
          }, 100)
          if (res.data.data.length == 0) {
            this.emptyFlag = true
          } else {
            this.emptyFlag = false
          }
        } else {
          Toast.fail('加载失败')
        }
      })
    },
    //收藏
    handleCollectionClick(item) {
      item.is_favorite = !item.is_favorite
      const params = new URLSearchParams()
      params.append('bid', item.bid)
      params.append('openid', this.$store.state.user.openid)
      addFavorite(params).then(res => {
        if (res.data.success == true) {
          Toast.success('收藏成功!')
        } else {
          Toast.fail('收藏失败!')
        }
      })
    },
    //取消收藏
    handleCancelCollectionClick(item) {
      console.info('111')
      item.is_favorite = !item.is_favorite
      const params = new URLSearchParams()
      params.append('bid', item.bid)
      params.append('openid', this.$store.state.user.openid)
      cancelFavorite(params).then(res => {
        if (res.data.success == true) {
          Toast.success('取消收藏成功!')
        } else {
          Toast.fail('取消收藏失败!')
        }
      })
    },
    //下拉刷新
    onRefresh() {
      this.favoritesList()
    },
    //item点击事件
    handleItemClick(item) {
      // console.info(item)
      this.$router.push({
        path: '/zdxl/xlxq',
        query: { bid: item.bid, near: this.$route.query.near }
      })
    }
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  }
}
</script>

<style lang="scss" scoped>
.scj {
  height: 100%;
  &-head {
    height: 40px;
    display: flex;
    &-left {
      padding: 10px 0 0 10px;
      box-sizing: border-box;
    }
    &-text {
      font-size: 18px;
      color: #33639e;
      box-sizing: border-box;
      padding-left: 7px;
      padding-top: 10px;
      font-weight: 600;
      letter-spacing: 2px;
    }
    &-right {
      position: absolute;
      right: 20px;
      top: 13px;
      letter-spacing: 1px;
      color: #33639e;
      font-weight: 600;
    }
  }
  &-body {
    height: calc(100% - 40px);
    background-color: #ececec;
    overflow: auto;
    &-item {
      // display: flex;
      box-sizing: border-box;
      padding-left: 7%;
      padding-top: 13px;
      margin-top: 10px;
      min-height: 15%;
      background-color: #ffffff;
      position: relative;
      &-icon {
        position: absolute;
        height: 100px;
        width: 26px;
        top: 30px;
        left: 15px;
      }
      &-name {
        padding-left: 10px;
        font-size: 15px;
        color: #33639e;
        font-weight: 600;
        width: 80%;
        min-height: 20px;
        line-height: 20px;
        box-sizing: border-box;
        padding-left: 30px;
      }
      &-cp {
        position: absolute;
        padding-left: 10px;
        padding-top: 3px;
        font-size: 10px;
        color: #4981c5;
        right: 20px;
        top: 15px;
      }
      &-status {
        position: absolute;
        top: 40%;
        right: 20px;
        z-index: 100;
      }
      &-check {
        position: absolute;
        left: 0%;
        top: 42%;
      }
      &-bottom {
        display: flex;
        height: 80px;
        position: relative;
        box-sizing: border-box;
        padding-left: 30px;
        padding-top: 15px;
      }
      &-star,
      &-right,
      &-end,
      &-begintime,
      &-endtime {
        font-size: 12px;
        color: #777777;
        height: 20px;
        line-height: 20px;
        position: absolute;
      }
      &-right {
        left: 40%;
      }
      &-end {
        left: 60%;
      }
      &-begintime {
        top: 50px;
      }
      &-endtime {
        left: 60%;
        top: 50px;
      }
    }
  }
}
</style>
